/**
 * @todo Workaround until Icon component is done, replace then
 */
const mountIcon = (cellular: string) => {
    if (['5G', '5GPlus'].indexOf(cellular) !== -1) {
        document.getElementsByClassName('hardware-details__container')[0].classList.add(`cellular-${cellular.toLowerCase()}`);
    }
};

export default mountIcon;
